import { jsx as r, jsxs as o } from "react/jsx-runtime";
import { useMultiStyleConfig as U, useBreakpointValue as x, Box as A, Center as C, VStack as b } from "@chakra-ui/react";
import { useDropzone as P } from "react-dropzone";
import { ArrowUpFromBracketIcon as z, CloudArrorUpIcon as M } from "../../../../icons/componentIcons.mjs";
import { Typography as n } from "../../../../dataDisplay/Typography/Typography.mjs";
import { Button as h } from "../../../Button/Button.mjs";
import "../../../Button/IconButton.mjs";
import "../../../Button/ButtonGroup.mjs";
import { formatBytes as R } from "../../fileUploadFunctions.mjs";
const G = ({
  name: l,
  onAddFiles: m,
  // 1 for MIME Types and 1 for displaying, [filetypes].join(' / ')
  acceptedFileTypes: y,
  allowMultiple: f = !1,
  "data-testid": e,
  error: d,
  fileTypesList: p = [],
  id: s,
  isDisabled: t,
  isReadOnly: v,
  isRequired: B,
  maxFileSize: a,
  ...u
}) => {
  const { getInputProps: $, getRootProps: g, isDragActive: j } = P({
    accept: y,
    multiple: f,
    maxSize: a,
    onDropAccepted: (c) => {
      m(
        c.map((i) => ({
          file: i,
          progressPercentage: 0
        }))
      );
    },
    onDropRejected: (c) => {
      m(
        c.map((i) => ({
          file: i.file,
          progressPercentage: 0,
          error: i.errors.map((w) => w.message).join(". ")
        }))
      );
    },
    disabled: !!t
  }), k = U("FileUpload");
  return x({ base: !0, md: !1 }, { fallback: "md" }) ? /* @__PURE__ */ r(A, { ...u, ...g(), display: "inline-block", tabIndex: -1, children: /* @__PURE__ */ r(
    h,
    {
      id: `${s}-uploadbtn`,
      name: `${l}-uploadbtn`,
      "data-testid": e && `${e}-uploadbtn`,
      variant: "tertiary",
      isDisabled: t,
      ...d && { border: "2px solid red", borderColor: "red.500" },
      rightIcon: /* @__PURE__ */ r(z, { variant: "light", size: "sm" }),
      children: "Upload"
    }
  ) }) : /* @__PURE__ */ o(
    C,
    {
      __css: k.dropzone,
      ...u,
      ...g(),
      ...j && { "data-dragActive": !0 },
      ...d && { "data-invalid": !0 },
      ...t && { disabled: !0 },
      children: [
        /* @__PURE__ */ r(
          "input",
          {
            id: s,
            name: l,
            "data-testid": e,
            ...t && { disabled: !0 },
            ...v && { readOnly: !0 },
            ...B && { required: !0, "aria-required": !0 },
            ...d && { "data-invalid": !0 },
            ...$()
          }
        ),
        /* @__PURE__ */ o(b, { spacing: 4, children: [
          /* @__PURE__ */ r(M, { variant: "light", size: "4xl" }),
          /* @__PURE__ */ r(n, { variant: "body", children: "Drag and drop files here" }),
          /* @__PURE__ */ r(n, { variant: "body", children: "OR" }),
          /* @__PURE__ */ r(
            h,
            {
              id: `${s}-browse`,
              name: `${l}-browse`,
              "data-testid": e && `${e}-browse`,
              variant: "tertiary",
              isDisabled: t,
              children: "Browse"
            }
          ),
          (p.length > 0 || a) && /* @__PURE__ */ o(b, { spacing: 0, children: [
            p.length > 0 && /* @__PURE__ */ o(n, { variant: "bodySmall", type: "secondary", children: [
              "File type(s): ",
              p.join(" / ")
            ] }),
            a && /* @__PURE__ */ o(n, { variant: "bodySmall", type: "secondary", children: [
              "File size limit: ",
              R(a)
            ] })
          ] })
        ] })
      ]
    }
  );
};
export {
  G as FileUploadDropZone
};
